import * as orderState from '../../constants/orderStateConstatns';

const progressStates = [orderState.ORDERED_BY_CUSTOMER,
  orderState.REQUESTED_FROM_SUPPLIER,
  orderState.APPROVED_BY_SUPPLIER,
  orderState.EXPECTED_IN_STOCK,
  orderState.IN_STOCK];
const readyStates = [orderState.SENDED_TO_CUSTOMER, orderState.RECEIVED_BY_CUSTOMER];
const canceledStates = [orderState.CANCELED_BY_SUPPLIER, orderState.CANCELED_BY_ADMIN];

export const isPortionStateSelected = (portion, isProgress, isCanceled, isReady, isArchived) => {
  if(!isProgress && !isCanceled && !isReady)
    return portion.isArchived === isArchived;

  const isProgressSelected = progressStates.some(elem => portion.state === elem) && isProgress;
  const isReadySelected = readyStates.some(elem => portion.state === elem) && isReady;
  const isCanceledSelected = canceledStates.some(elem => portion.state === elem) && isCanceled;

  const result = (isProgressSelected || isReadySelected || isCanceledSelected) && portion.isArchived === false;

  return result || (portion.isArchived === true && isArchived);
};

export const filterSelectedPortion = (order, isProgress, isCanceled, isReady, isArchived) => {
  let portions = order.portions.filter(portion => isPortionStateSelected(portion, isProgress, isCanceled, isReady, isArchived));
  return {...order, portions: portions };
};



/** WEBPACK FOOTER **
 ** ./src/logic/helpers/orderStateHelper.js
 **/